import Vue from 'vue/dist/vue.min.js';
import showdown from 'showdown';
import "regenerator-runtime/runtime";

export default function chatModal() {
    
    // #region initial setup
    // DEVELOPMENT ONLY, comment out for deployments
    // const chatsTest = [
    //     {
    //         "chat_uuid": "",
    //         "messages": [
    //         {
    //             "text": "Hello, how can I help you?",
    //             "who": "bot",
    //             "at": "2026-05-18T20:33:56.940Z"
    //         }
    //         ],
    //         "lastActive": "2026-05-18T20:33:56.940Z"
    //     },
    //     {
    //         "chat_uuid": "d7f652f639294b0c8624bcc86d36278c",
    //         "messages": [
    //         {
    //             "text": "What can we help you with today?  You can ask me anything about Badger Meter's products and services.",
    //             "who": "bot",
    //             "at": "2026-05-18T20:16:44.307Z"
    //         },
    //         {
    //             "text": "what is a meter?",
    //             "who": "user",
    //             "at": "2026-05-18T20:17:17.165Z",
    //             "feedbackText": null,
    //             "feedbackFlag": null,
    //             "chat_doc_id": null,
    //             "disclaimer": null
    //         },
    //         {
    //             "text": "<p>A meter is a device used to measure something being delivered to a location. In the context of BEACON, a meter typically refers to water meters. Additionally, a meter can also mean a unit of measure.</p>\n<p>There are different types of meters used in water measurement, including:</p>\n<ul>\n<li>Main Meter: The primary meter used to measure flow for which customers will be billed.</li>\n<li>Deduct Meter: A meter whose flow is deducted from the usage total so the customer is not billed for it.</li>\n<li>Demand Meter: Meters that measure water being consumed within a DMA (District Metered Area) zone.</li>\n<li>Hydrant Meter: A portable device attached to a fire hydrant to measure and monitor water volume used for temporary or non-permanent access, such as construction or emergency services.</li>\n<li>Supply Meter: Meters that measure water flowing into a DMA zone <a href=\"https://helpbeaconama.net/appendices/beacon-glossary-of-terms/\" title=\"BEACON System Glossary\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>[1]</strong></a>. </li>\n</ul>\n<p>If you need more details on any specific type of meter, feel free to ask!</p>",
    //             "who": "bot",
    //             "at": "2026-05-18T20:17:31.728Z",
    //             "feedbackText": "Did you like the response?",
    //             "feedbackFlag": false,
    //             "chat_doc_id": "71cc1ba5ca4a44059c46b4cacb1380ff",
    //             "disclaimer": "This information was generated by an AI system and should not be solely relied upon for decision-making. Always verify information with credible sources and consult with relevant experts before taking any action based on AI-generated content."
    //         },
    //         {
    //             "text": "what is a meter?",
    //             "who": "user",
    //             "at": "2026-05-18T20:18:17.165Z",
    //             "feedbackText": null,
    //             "feedbackFlag": null,
    //             "chat_doc_id": null,
    //             "disclaimer": null
    //         },
    //         {
    //             "text": "<p>A meter is a device used to measure something being delivered to a location. In the context of BEACON, a meter typically refers to water meters. Additionally, a meter can also mean a unit of measure.</p>\n<p>There are different types of meters used in water measurement, including:</p>\n<ul>\n<li>Main Meter: The primary meter used to measure flow for which customers will be billed.</li>\n<li>Deduct Meter: A meter whose flow is deducted from the usage total so the customer is not billed for it.</li>\n<li>Demand Meter: Meters that measure water being consumed within a DMA (District Metered Area) zone.</li>\n<li>Hydrant Meter: A portable device attached to a fire hydrant to measure and monitor water volume used for temporary or non-permanent access, such as construction or emergency services.</li>\n<li>Supply Meter: Meters that measure water flowing into a DMA zone <a href=\"https://helpbeaconama.net/appendices/beacon-glossary-of-terms/\" title=\"BEACON System Glossary\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>[1]</strong></a>. </li>\n</ul>\n<p>If you need more details on any specific type of meter, feel free to ask!</p>",
    //             "who": "bot",
    //             "at": "2026-05-18T20:18:31.728Z",
    //             "feedbackText": "Did you like the response?",
    //             "feedbackFlag": false,
    //             "chat_doc_id": "71cc1ba5ca4a44059c46b4cacb1380ff",
    //             "disclaimer": "This information was generated by an AI system and should not be solely relied upon for decision-making. Always verify information with credible sources and consult with relevant experts before taking any action based on AI-generated content."
    //         },
    //         ],
    //         "lastActive": "2026-05-18T20:18:44.307Z"
    //     }
    // ];
    
    // auto-load chatsTest (development only)
    if (typeof chatsTest !== 'undefined' && Array.isArray(chatsTest)) {
        try {
            localStorage.setItem('chat_sessions_v1', JSON.stringify(chatsTest));
        } catch (e) {}
    }

    /*
    there is bug where disclaimer do not get stored, fixed by passing the value through this component
    */
    const chatModalVm = new Vue({
        el: document.getElementById('chatModal'),
        data: {
            opened: false,
            enlarged: false,
            showHistory: false,
            generatingResponse: false,
            isMobile: false,
            showTooltip: false,
            tooltipTimer: null,
            autoHideTimer: null,
            disclaimer: '',
            inputOpened: false,
            sources: [],
        },
        watch: {
            // to hide history on mobile when shrinking from desktop to mobile while history is open
            isMobile(newValue) {
                if (newValue) {
                    this.showHistory = false;
                    this.enlarged = false;
                }
            },
            opened(newVal) {
                if (newVal) {
                    this.showTooltip = false;
                    this.clearTimers();
                }
            }
        },
        mounted() {
            const mediaQuery = window.matchMedia('(max-width: 899px)');
            this.isMobile = mediaQuery.matches;
            const handleResize = (e) => {
                this.isMobile = e.matches;
            };
            if (mediaQuery.addEventListener) {
                mediaQuery.addEventListener('change', handleResize);
            } else { // fallback for older browsers
                mediaQuery.addListener(handleResize);
            }
            // tooltip by session
            const tooltipShownThisSession = sessionStorage.getItem('tooltip_shown');
            if (!tooltipShownThisSession) {
                this.tooltipTimer = setTimeout(() => {
                    if (!this.opened) {
                        this.showTooltip = true;
                        sessionStorage.setItem('tooltip_shown', 'true');
                        this.autoHideTimer = setTimeout(() => {
                            this.showTooltip = false;
                        }, 10000);
                    }
                }, 30000);
            }
        },
        methods: {
            handleOpenModal() {
                if (!this.inputOpened) {
                    this.inputOpened = true;
                    setTimeout(() => {
                        openChat(getCurrentChatUuid());
                        renderChatSessionList();
                    }, 350);
                }
            },
            handleCloseModal() {
                if (this.inputOpened) {
                    closeChat();
                    setTimeout(() => {
                        this.inputOpened = false;
                    }, 200);
                }
            },
            clearTimers() {
                if (this.tooltipTimer) {
                    clearTimeout(this.tooltipTimer);
                    this.tooltipTimer = null;
                }
                if (this.autoHideTimer) {
                    clearTimeout(this.autoHideTimer);
                    this.autoHideTimer = null;
                }
            },
        }
    });
    // #endregion

    // #region events

    // close when pressing Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
            if (document.body.classList.contains('chat-open')) {
                closeChat();
            }
        }
    });
    
    document.addEventListener('click', (e) => {
        const toggle = e.target.closest && e.target.closest('.chat-icon-image');
        const close = e.target.closest && e.target.closest('.chat-modal__header-close');
        const enlarge = e.target.closest && e.target.closest('.chat-modal__content__main__enlarge');
        const enlargeHistory = e.target.closest && e.target.closest('.chat-modal__content__history__enlarge');
        const back = e.target.closest && e.target.closest('.chat-modal__header-back');
        const newChat = e.target.closest && e.target.closest('.chat-modal__content__history__new-session');
        const sessionItem = e.target.closest && e.target.closest('.chat-modal__content__history__sessions__list-item');

        if (toggle) {
            e.preventDefault();
            chatModalVm.handleOpenModal();
            return;
        }
        if (close) {
            e.preventDefault();
            chatModalVm.handleCloseModal();
            return;
        }
        if (enlarge) {
            e.preventDefault();
            chatModalVm.enlarged = !chatModalVm.enlarged;
            return;
        }
        if (enlargeHistory) {
            e.preventDefault();
            chatModalVm.enlarged = !chatModalVm.enlarged;
            return;
        }
        if (back) {
            e.preventDefault();
            chatModalVm.showHistory = !chatModalVm.showHistory;
            return;
        }
        if (newChat) {
            e.preventDefault();
            createNewChatSession(true);
            chatModalVm.showHistory = false;
            return;
        }
        if (sessionItem) {
            const chat_uuid = sessionItem.getAttribute('data-chat-uuid');
            setCurrentChatUuid(chat_uuid);
            renderMessages(chat_uuid);
            if (!chatModalVm.enlarged)
                chatModalVm.showHistory = false;
            return;
        }
    });

    // open the modal when an external button (elsewhere on the page) sets this URL anchor
    const CHAT_MODAL_HASH = '#open-ai-chat';

    const openChatFromHash = () => {
        if (window.location.hash !== CHAT_MODAL_HASH) return;

        chatModalVm.handleOpenModal();
        // remove the anchor so the URL stays clean and still fires on repeated clicks
        history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    // external buttons that change the hash trigger
    window.addEventListener('hashchange', openChatFromHash);
    // cover the case where the page is loaded with the anchor already in the URL
    openChatFromHash();

    // handle form submit via delegation
    document.addEventListener('submit', (e) => {
        e.preventDefault();
        const form = e.target && (e.target.id === 'chatForm' || e.target.closest && e.target.closest('#chatForm')) ? e.target : null;
        if (!form) return;
        if (chatModalVm.generatingResponse) return; // prevent submitting new messages while waiting for response
        const input = form.querySelector('#chatInput') || form.querySelector('.chat-modal__content__main__input');
        const button = form.querySelector('#chatSendButton') || form.querySelector('.chat-modal__content__main__send');
        const value = input && input.value ? input.value.trim() : '';
        input.blur(); // remove focus from input after submit
        button.blur(); // remove focus from button after submit
        const chat_uuid = getCurrentChatUuid();

        // add to storage and re-render conversation
        if (value) {
            addStoredMessage(value, 'user', chat_uuid);
            renderMessages(chat_uuid);
            renderChatSessionList();
        }

        // clear input after submit
        if (input) input.value = '';

        // send request to AI conversation endpoint
        conversationConstructor(chat_uuid);
    });

    // #endregion

    // #region helpers for managing storage of multiple chats
    
    const setAllChatSessions = (sessions) => {
        const arr = Array.isArray(sessions) ? sessions : [];
        // keep only the most recent MAX_CHATS
        arr.sort((a, b) => new Date(b.lastActive) - new Date(a.lastActive));
        const trimmed = arr.slice(0, MAX_CHATS);
        const raw = JSON.stringify(trimmed);
        if (storageManagerInstance) {
            storageManagerInstance.set(CHAT_STORAGE_KEY, raw);
        } else {
            localStorage.setItem(CHAT_STORAGE_KEY, raw);
        }
    };

    const openChat = (chat_uuid) => {
        document.body.classList.add('chat-open');
        const modal = chatModalVm.$el;
        if (!modal) return;
        chatModalVm.opened = true;

        // render stored messages and focus input (wait for the modal to become visible and for any Vue rendering to complete before focusing)
        renderMessages(chat_uuid);

        // focus only when messages section is active cause animations do not work when the other div is hidden
        if (!chatModalVm.showHistory) {
            const input = document.getElementById('chatInput') || document.querySelector('.chat-modal__content__main__input');
            const tryFocus = () => {
                if (input && typeof input.focus === 'function') {
                    input.focus();
                    // some browsers may not move focus immediately if element is transitioning, final attempt after a short delay
                    if (document.activeElement !== input) {
                        setTimeout(() => { input.focus(); }, 120);
                    }
                    return;
                }
            };

            // schedule focus after paint and a brief delay to allow CSS transitions to apply
            requestAnimationFrame(() => setTimeout(tryFocus, 20));
        }
    };

    const renderMessages = (chat_uuid) => {
        const vm = ensureMessagesVm(chat_uuid);
        if (!vm) return;
        vm.storedMessages = getStoredMessages(chat_uuid);
        vm.$nextTick(() => {
            const container = document.querySelector('.chat-modal__content__main__body');
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        });
    };

    // rendering Vue-based: ensure a Vue VM mounts to #chatMessages and renders stored messages
    let ensureMessagesVm = (chat_uuid) => {
        try {
            if (window.__chatMessagesVm && window.__chatMessagesVm.chat_uuid === chat_uuid) return window.__chatMessagesVm;
            const container = document.querySelector('.chat-modal__content__main__messages-inner');
            const scrollContainer = document.querySelector('.chat-modal__content__main__body');
            
            if (!container) return null;

            const scrollToBottom = () => {
                scrollContainer.scrollTop = scrollContainer.scrollHeight;
            };

            // streaming scroll functionality
            let maxAllowedScrollTop = null;
            // when the user scrolls manually during a streaming response, stop the calculated auto-scroll
            let userScrolledDuringStream = false;
            // track the last position
            let expectedScrollTop = null;
            // when locked, hold the scroll at a fixed position through reflows (used at stream end
            // so the browser does not re-anchor a near-bottom viewport to the very bottom)
            let lockScrollPos = false;
            let lockScrollValue = 0;
            const setScrollTop = (value) => {
                scrollContainer.scrollTop = value;
                // store the actual resulting position
                expectedScrollTop = scrollContainer.scrollTop;
            };
            // any scroll that lands away from position is treated as a manual user scroll
            scrollContainer.addEventListener('scroll', () => {
                if (!window.__chatModalVm || !window.__chatModalVm.generatingResponse) return;
                // only react once we have a known position to compare against,
                // otherwise an early render-driven scroll could be mistaken for a user scroll
                if (expectedScrollTop !== null && Math.abs(scrollContainer.scrollTop - expectedScrollTop) > 2) {
                    userScrolledDuringStream = true;
                }
            }, { passive: true });
            const scrollToBottomOnStreaming = () => {
                // user took control of the scroll, do not force position anymore
                if (userScrolledDuringStream) return;
                // calculate relative static position from scroll
                if (maxAllowedScrollTop === null) {
                    // calculate top if container grows enough to have an active scroll
                    const canScroll = scrollContainer.scrollHeight > scrollContainer.clientHeight;
                    
                    if (canScroll) {
                        // last user prompt
                        const userDates = scrollContainer.querySelectorAll('.chat-message-date--user');
                        
                        if (userDates.length > 0) {
                            const lastUserDate = userDates[userDates.length - 1];
                            // relative element position at the scroll start of container
                            const elementTopInScroll = lastUserDate.offsetTop;
                            // remove internal padding top if container has it
                            const containerPaddingTop = parseInt(window.getComputedStyle(scrollContainer).paddingTop) || 0;
                            // touch top border
                            maxAllowedScrollTop = elementTopInScroll - containerPaddingTop;
                        }
                    }
                }

                // validate before moving scroll
                if (maxAllowedScrollTop !== null) {
                    const targetScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight;
                    
                    // block scroll when target is reached
                    if (targetScroll >= maxAllowedScrollTop) {
                        setScrollTop(maxAllowedScrollTop);
                    } else {
                        setScrollTop(targetScroll);
                    }
                } else {
                    setScrollTop(scrollContainer.scrollHeight);
                }
            };

            // create Vue instance and attach to global so streaming code can access it
            window.__chatMessagesVm = new Vue({
                el: container,
                data: {
                    chat_uuid: chat_uuid,
                    storedMessages: getStoredMessages(chat_uuid),
                    streamingUpdateHtml: null,
                    streamingRaw: '',
                    streamingTranslatableSummary: window.aiChatSummaryLoading || '...',
                    relatedQuestions: [],
                    streamingTime: null,
                },
                template: `
                    <div class="chat-modal__content__main__messages-inner">
                        <div v-for="(m, idx) in storedMessages" :key="idx" class="chat-message-wrapper">
                            <div :class="[m.who === 'user' ? 'chat-message-date--user' : 'chat-message-date--bot']">{{ formatTime(m.at) }}</div>
                            <div :class="['chat-message', m.who === 'user' ? 'chat-message--user' : 'chat-message--bot']" v-html="m.text"></div>
                            <div v-if="m.feedbackText" class="chat-message-feedback">
                                <span v-html="m.feedbackText"></span>
                                <span :class="['feedbackFlagDislike', m.feedbackFlag === false ? 'active' : '']" v-on:click="sendFeedback($event, m.chat_doc_id, false)"></span>
                                <span :class="['feedbackFlagLike', m.feedbackFlag === true ? 'active' : '']" v-on:click="sendFeedback($event, m.chat_doc_id, true)"></span>
                            </div>
                            <div v-if="m.disclaimer" class="chat-message--disclaimer" v-html="m.disclaimer"></div>
                            <div v-if="m.sources" class="chat-message--sources">
                                <div class="chat-message chat-message--resources">{{ m.supporting_resources }}</div>
                                <div :class="['chat-message', 'chat-message--sources-wrapper', { 'isExpanded': m.isExpanded }]">
                                    <div class="chat-message chat-message--sources-item" v-for="(source, idx) in m.sources" :key="idx">
                                        <div v-if="source.source_thumbnail" class="sources-item-thumbnail-wrapper">
                                            <img :src="source.source_thumbnail" />
                                            <svg
                                                v-show="!(source.source_url && !source.source_url.includes('badgermeter.widen.net'))"
                                                version="1.1" 
                                                id="Layer_1" 
                                                xmlns="http://w3.org" 
                                                xmlns:xlink="http://w3.org" 
                                                x="0px" 
                                                y="0px" 
                                                viewBox="0 0 126 127" 
                                                enable-background="new 0 0 126 127" 
                                                xml:space="preserve" 
                                                preserveAspectRatio="none" 
                                                style="width: 17px; height: 17px; position: absolute; top: -2px; right: -2px; display: block; overflow: hidden; transform: translateY(-0.5px); -webkit-transform: translateY(-0.5px);">
                                            <path fill="#FFFFFF" opacity="1.000000" stroke="none" d="M3.000000,1.000000 C44.260300,1.000000 85.520599,1.000000 127.000000,1.000000 C127.000000,42.020634 127.000000,83.041656 126.671898,124.451576 C125.843445,124.402466 125.315857,123.991699 124.846619,123.522575 C85.030693,83.716347 45.216972,43.907921 5.421911,4.080841 C4.505110,3.163303 3.802512,2.031734 3.000000,1.000000 z"/>
                                            <path fill="#A8ACAE" opacity="1.000000" stroke="none" d="M2.500000,1.000000 C3.802512,2.031734 4.505110,3.163303 5.421911,4.080841 C45.216972,43.907921 85.030693,83.716347 124.846619,123.522575 C125.315857,123.991699 125.843445,124.402466 126.671898,124.920235 C127.923126,128.438095 125.680817,128.025101 123.499985,128.023392 C82.666687,127.991562 41.833355,128.000000 1.000015,128.000000 C1.000000,87.000023 0.990577,46.000031 1.042051,5.000113 C1.043726,3.666343 1.666667,2.333353 2.500000,1.000000 M43.405430,64.094589 C34.404121,55.083187 25.402815,46.071793 15.557283,36.215225 C15.557283,62.900669 15.557283,88.224716 15.557283,113.797554 C41.284889,113.797554 66.658691,113.797554 93.133293,113.797554 C76.291084,96.963974 60.098179,80.779358 43.405430,64.094589 z"/>
                                            <path fill="#FDFDFD" opacity="1.000000" stroke="none" d="M43.655350,64.344666 C60.098179,80.779358 76.291084,96.963974 93.133293,113.797554 C66.658691,113.797554 41.284889,113.797554 15.557283,113.797554 C15.557283,88.224716 15.557283,62.900669 15.557283,36.215225 C25.402815,46.071793 34.404121,55.083187 43.655350,64.344666 z"/>
                                            </svg>
                                        </div>
                                        <div v-if="source.source_title" class="sources-item-text">
                                            <span class="sources-item-title" v-html="source.source_title"></span>&nbsp;[{{ idx + 1 }}]
                                            <span class="sources-item-description" v-if="source.source_description" v-html="source.source_description"></span>
                                        </div>
                                        <div v-if="source.source_url" v-on:click="imageRedirect(source.source_url)"
                                            :class="['sources-item-url', { attachLink: source.source_url && !source.source_url.includes('badgermeter.widen.net') }]"
                                        ></div>
                                    </div>
                                </div>
                                <div v-if="m.see_more && !m.isExpanded" class="chat-message chat-message--resources-more" v-on:click="seeMore(m)">{{ m.see_more }}</div>
                            </div>
                        </div>
                        <div class="chat-message-wrapper chat-message-wrapper--streaming" v-if="!isStreaming && streamingUpdateHtml === null && relatedQuestions.length > 0">
                            <div class="chat-message chat-message--try-asking" v-show="tryAsking">{{ tryAsking }}</div>
                            <div class="chat-message chat-message--bot" v-for="(q, idx) in relatedQuestions" :key="idx">
                                <div class="chat-message--related-question" v-html="q" v-on:click="sendRelatedQuestion($event)"></div>
                            </div>
                        </div>
                        <div class="chat-message-wrapper chat-message-wrapper--streaming" v-if="isStreaming">
                            <div v-if="streamingUpdateHtml !== null" class="chat-message-date--bot">{{ streamingTime }}</div>
                            <div v-if="streamingUpdateHtml !== null" class="chat-message chat-message--bot" v-html="streamingUpdateHtml"></div>
                            <div v-else class="chat-message chat-message--bot chat-message--typing">
                                <span class="typing">{{ streamingTranslatableSummary }}</span>
                            </div>
                        </div>
                    </div>
                `,
                mounted() {
                    this.$nextTick(() => scrollToBottom());
                },
                updated() {
                    // hold the user's position through end-of-stream reflows
                    if (lockScrollPos) {
                        scrollContainer.scrollTop = lockScrollValue;
                        return;
                    }
                    if (maxAllowedScrollTop !== null && !userScrolledDuringStream) {
                        setScrollTop(maxAllowedScrollTop);
                    }
                },
                watch: {
                    streamingUpdateHtml(newVal, oldVal) {
                        // set streaming time at the start of streaming when first chunk is received
                        if (newVal) {
                            this.streamingTime = this.formatTime(new Date());
                        }
                        // reset scroll control at the start of every new AI response
                        if (newVal && !oldVal) {
                            userScrolledDuringStream = false;
                            expectedScrollTop = null;
                            lockScrollPos = false;
                        }
                        if (!newVal) {
                            if (userScrolledDuringStream) {
                                // user took control: preserve their exact position through the final
                                // DOM swap (streaming node -> stored message + related questions)
                                // so the browser does not auto-scroll to the bottom
                                lockScrollValue = scrollContainer.scrollTop;
                                lockScrollPos = true;
                                const keep = () => { scrollContainer.scrollTop = lockScrollValue; };
                                this.$nextTick(keep);
                                requestAnimationFrame(keep);
                                setTimeout(() => {
                                    lockScrollPos = false;
                                    maxAllowedScrollTop = null;
                                    userScrolledDuringStream = false;
                                    expectedScrollTop = null;
                                }, 120);
                                return;
                            }
                            // once finish, make sure of position before clean up variable
                            if (maxAllowedScrollTop !== null) {
                                setScrollTop(maxAllowedScrollTop);
                            }
                            // micro delay so cycle updated finishes position before reset
                            setTimeout(() => {
                                maxAllowedScrollTop = null;
                                userScrolledDuringStream = false;
                            }, 50);
                            return;
                        }
                        this.$nextTick(() => { scrollToBottomOnStreaming(); });
                    }
                },
                methods: {
                    imageRedirect(e) {
                        window.open(e);
                    },
                    seeMore(message) {
                        if (typeof message.isExpanded === 'undefined') {
                            this.$set(message, 'isExpanded', true);
                        } else {
                            message.isExpanded = !message.isExpanded;
                        }
                    },
                    formatTime(date) {
                        return new Date(date)
                            .toLocaleTimeString('en-US', {
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                            })
                            .replace(' AM', 'am')
                            .replace(' PM', 'pm')
                            .replace(' ', '');
                    },
                    sendRelatedQuestion(e) {
                        const text = e.currentTarget.innerText;
                        const input = document.getElementById('chatInput') || document.querySelector('.chat-modal__content__main__input');
                        if (input) {
                            input.value = text;
                            const form = input.closest('form');
                            if (form) {
                                form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                            }
                        }
                    },
                    async sendFeedback(event, chat_doc_id, flag) {
                        const target = event.currentTarget;
                        const feedbackContainer = target && target.parentElement;
                        if (feedbackContainer) {
                            const feedbackButtons = feedbackContainer.querySelectorAll('.feedbackFlagDislike, .feedbackFlagLike');
                            feedbackButtons.forEach((button) => button.classList.remove('active'));
                        }
                        if (target) {
                            target.classList.add('active');
                        }
                        var beaconFeedback = "/api/beaconfeedback";
                        try {
                            const response = await fetch(beaconFeedback, {
                                method: 'PATCH',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    docId: chat_doc_id,
                                    rating: flag === true ? 5 : 1,
                                    feedback: "",
                                }),
                            });
                            const data = await response.json();
                            if (data.success) {
                                console.log("feedback submitted successfully");
                                // update feedback flag in the message chat_doc_id
                                let sessions = getAllChatSessions();
                                let updated = false;
                                for (let session of sessions) {
                                    if (session.messages && Array.isArray(session.messages)) {
                                        if (updated) break;
                                        for (let msg of session.messages) {
                                            if (msg.chat_doc_id === chat_doc_id) {
                                                msg.feedbackFlag = flag === true ? true : false;
                                                updated = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (updated) {
                                    setAllChatSessions(sessions);
                                }
                            } else {
                                console.log("feedback request error message: " + data.message);
                            }
                        } catch (error) {
                            console.log("Unable to submit user feedback: " + error);
                        }
                    }
                },
                computed: {
                    isStreaming() {
                        return window.__chatModalVm && window.__chatModalVm.generatingResponse;
                    },
                    tryAsking() {
                        return window.aiChatTryAsking ? window.aiChatTryAsking : '';
                    }
                }
            });
            return window.__chatMessagesVm;
        } catch (err) {
            return null;
        }
    };

    const getStoredMessages = (chat_uuid) => {
        let sessions = getAllChatSessions();
        if (!sessions) return;
        let session = sessions.find(s => s.chat_uuid === chat_uuid);
        // allow fallback to empty-uuid session for new chat that have not received a backend uuid yet
        if (!session) session = sessions.find(s => s.chat_uuid === '');
        if (!session) return;
        return session.messages;
    };

    const getUserMessageCount = (chat_uuid) => {
        const messages = getStoredMessages(chat_uuid);
        if (!Array.isArray(messages) || messages.length === 0) return 0;
        return messages.filter(m => m && m.who === 'user').length;
    };

    const addStoredMessage = (
        text,
        who = 'user',
        chat_uuid,
        feedbackText = null,
        feedbackFlag = null,
        chat_doc_id = null,
        disclaimer = null,
        sources = null,
        supporting_resources = null,
        see_more = null,
        isExpanded = null
    ) => {
        // allow empty chat_uuid for new chats
        if (typeof chat_uuid === 'undefined' || chat_uuid === null || chat_uuid === '') chat_uuid = getCurrentChatUuid();
        let entry = {
            text: String(text || ''),
            who: who,
            at: new Date().toISOString(),
            feedbackText: feedbackText,
            feedbackFlag: feedbackFlag,
            chat_doc_id: chat_doc_id,
            disclaimer: disclaimer,
            sources: sources,
            supporting_resources: supporting_resources,
            see_more: see_more,
            isExpanded: isExpanded
        };

        // check if adding this message would exceed localStorage limit
        let tryCount = 0;
        while (getLocalStorageSize() > (LOCALSTORAGE_LIMIT_BYTES - LOCALSTORAGE_SAFE_MARGIN) && tryCount < 10) {
            removeOldestMessageFromAnyChat();
            tryCount++;
        }

        let session = updateChatSession(chat_uuid, (s) => {
            if (s.messages.length >= MAX_MESSAGES_PER_CHAT) s.messages.shift();
            s.messages.push(entry);
        });

        // if Vue VM is present, update it too so UI updates without re-rendering storage-only path
        if (window.__chatMessagesVm && window.__chatMessagesVm.storedMessages && window.__chatMessagesVm.chat_uuid === chat_uuid) {
            if (window.__chatMessagesVm.storedMessages.length >= MAX_MESSAGES_PER_CHAT)
                window.__chatMessagesVm.storedMessages.shift();
            window.__chatMessagesVm.storedMessages.push(entry);
        }
        return session.messages;
    };

    const updateChatSession = (chat_uuid, updateFn) => {
        let sessions = getAllChatSessions();
        if (!sessions) return;
        let idx = sessions.findIndex(s => s.chat_uuid === chat_uuid);
        if (idx === -1) {
            // allow fallback to empty-uuid session for new chat
            idx = sessions.findIndex(s => s.chat_uuid === '');
            if (idx === -1) return;
        }
        const session = sessions[idx];
        updateFn(session);
        session.lastActive = new Date().toISOString();
        // move to front
        sessions.splice(idx, 1);
        sessions.unshift(session);
        setAllChatSessions(sessions);
        return session;
    };

    const conversationConstructor = async (chat_uuid) => {
        if (typeof chat_uuid === 'undefined') chat_uuid = getCurrentChatUuid();
        const vm = ensureMessagesVm(chat_uuid);
        if (vm) {
            chatModalVm.generatingResponse = true; // flag to prevent multiple submits while waiting for response
        }
        var converter = new showdown.Converter({ disableForced4SpacesIndentedSublists: true, openLinksInNewWindow: true });
        converter.setOption('tables', true);

        // get messages for this chat
        let messages = getStoredMessages(chat_uuid);
        let prompt = JSON.stringify(messages);
        if (!messages || messages.length === 0) {
            console.log("prompt is empty");
            addStoredMessage(window.aiChatTechnicalIssues, 'bot', chat_uuid);
            chatModalVm.generatingResponse = false;
            return;
        }

        const tokenResponse = await fetch("/api/beaconstreamtoken", {
            method: 'POST',
        });

        const responseJson = await tokenResponse.json();

        const sseUrl = window.aiConversationUrl;
        // get language from url (only xx-xx format)
        const languageRegex = /^[a-z]{2}-[a-z]{2}$/i;
        const pathSegments = window.location.pathname.split('/');
        // search in the array if a segment matches format
        const foundLanguage = pathSegments.find(segment => languageRegex.test(segment));
        const languageValue = foundLanguage || 'en-us';
        const sseUrlWithParam = `${sseUrl}?local=${languageValue}`;

        if (!responseJson.success) {
            console.log("token request failed");
            addStoredMessage(window.aiChatTechnicalIssues, 'bot', chat_uuid);
            chatModalVm.generatingResponse = false;
            return;
        }

        const headers = {
            'Authorization': `Bearer ${responseJson.content.token}`
        };

        let lastPrompt = '';
        try {
            const arr = JSON.parse(prompt);
            if (Array.isArray(arr) && arr.length > 0) {
                lastPrompt = arr[arr.length - 1].text || '';
            }
        } catch (e) {
            lastPrompt = '';
        }

        // if chat_uuid is empty, do not send it in the requestBody
        const requestBody = chat_uuid ? { prompt: lastPrompt, chat_uuid: chat_uuid } : { prompt: lastPrompt };

        const response = await fetch(sseUrlWithParam, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            console.log("conversation request failed");
            addStoredMessage(window.aiChatTechnicalIssues, 'bot', chat_uuid);
            chatModalVm.generatingResponse = false;
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let partialChunk = '';

        function processChunk(chunk) {
            chunk = partialChunk + chunk;
            const events = chunk.split('\n\n');
            partialChunk = events.pop();
            events.forEach(event => {
                const [typeLine, dataLine] = event.split('\n');
                const eventType = typeLine?.replace('event: ', '').trim();
                const eventData = dataLine?.replace('data: ', '').trim();
                if (eventData) processEvent(eventType, eventData);
            });
        }

        function processEvent(type, data) {
            const parsedData = JSON.parse(data);
            
            if (type === 'update') {
                // if backend returns a new chat_uuid, update the session in storage
                if (parsedData.chat_uuid && chat_uuid !== parsedData.chat_uuid) {
                    // find the session with empty chat_uuid and update it
                    let sessions = getAllChatSessions();
                    let idx = sessions.findIndex(s => s.chat_uuid === '');
                    if (idx !== -1) {
                        sessions[idx].chat_uuid = parsedData.chat_uuid;
                        sessions[idx].lastActive = new Date().toISOString();
                        setAllChatSessions(sessions);
                    }
                    if (storageManagerInstance)
                        storageManagerInstance.set('CURRENT_CHAT_UUID', parsedData.chat_uuid);
                    else
                        localStorage.setItem('CURRENT_CHAT_UUID', parsedData.chat_uuid);
                    currentChatUuid = parsedData.chat_uuid;
                    renderChatSessionList();
                }
                // accumulate streaming partial raw content and convert accumulated buffer
                const vm = ensureMessagesVm(chat_uuid);
                if (vm) {
                    if (parsedData.content && parsedData.content.trim().length > 0) {
                        vm.streamingRaw = String(vm.streamingRaw || '') + String(parsedData.content);
                        vm.streamingUpdateHtml = converter.makeHtml(vm.streamingRaw);
                    }
                }
            }
            else if (type === 'sources') { // disclaimer comes only in sources event
                chatModalVm.disclaimer = parsedData.disclaimer;
                if (Array.isArray(parsedData?.sources)) {
                    chatModalVm.sources = parsedData.sources.map(source => {
                        const cleanTitle = typeof source?.source_title === 'string' 
                        ? source.source_title.replace(/\\/g, '') : (source?.source_title || '');
                        return {
                            source_url: source?.source_url || '',
                            source_thumbnail: source?.source_thumbnail || '',
                            source_title: cleanTitle,
                            source_description: source?.source_summary || ''
                        };
                    });
                }
            }
            else if (type === 'final_update') {
                // final update: persist only final content as a stored bot message and clear streaming placeholder
                let realChatUuid = chat_uuid;
                if (parsedData.chat_uuid && chat_uuid !== parsedData.chat_uuid) {
                    // update session uuid if needed
                    let sessions = getAllChatSessions();
                    let idx = sessions.findIndex(s => s.chat_uuid === '');
                    if (idx !== -1) {
                        sessions[idx].chat_uuid = parsedData.chat_uuid;
                        sessions[idx].lastActive = new Date().toISOString();
                        setAllChatSessions(sessions);
                    }
                    if (storageManagerInstance)
                        storageManagerInstance.set('CURRENT_CHAT_UUID', parsedData.chat_uuid);
                    else
                        localStorage.setItem('CURRENT_CHAT_UUID', parsedData.chat_uuid);
                    currentChatUuid = parsedData.chat_uuid;
                    realChatUuid = parsedData.chat_uuid;
                    renderChatSessionList();
                }
                const vm = ensureMessagesVm(realChatUuid);
                let raw = String(parsedData.content || '');
                const finalHtml = converter.makeHtml(raw);
                // store disclaimer in case there is only one user message in the session
                const storeDisclaimer = getUserMessageCount(realChatUuid) === 1;
                addStoredMessage(
                    finalHtml,
                    'bot',
                    realChatUuid,
                    window.aiChatLikeResponse,
                    null,
                    parsedData.chat_doc_id,
                    storeDisclaimer ? chatModalVm.disclaimer : null,
                    chatModalVm.sources? chatModalVm.sources : null,
                    window.aiChatSupportingResources || 'Supporting Resources',
                    window.aiChatSeeMore || 'see more',
                    false
                );
                if (vm) {
                    vm.streamingUpdateHtml = null;
                    vm.streamingRaw = '';
                    vm.relatedQuestions = parsedData.related_questions;
                }
                createNewChatSession(false); // ensure there is always an empty-uuid session for new chat creation
            }
            else if (type === 'done') {
                chatModalVm.generatingResponse = false;
                reader.cancel();
            }
        };
        reader.read().then(function process({ done, value }) {
            if (done) {
                chatModalVm.generatingResponse = false;
                return;
            }
            processChunk(decoder.decode(value, { stream: true }));
            reader.read().then(process);
        });
    };

    // #endregion

    // debug marker so we can verify the module initialized at runtime
    if (document && document.body) document.body.dataset.chatInit = '1';
    window.__chatModalVm = chatModalVm;
    console.debug && console.debug('[chat-modal] initialized');

    const CHAT_STORAGE_KEY = 'chat_sessions_v1'; // stores array of chat sessions
    const MAX_CHATS = 100;
    const MAX_MESSAGES_PER_CHAT = 50;
    const LOCALSTORAGE_LIMIT_BYTES = 5 * 1024 * 1024; // 5MB
    const LOCALSTORAGE_SAFE_MARGIN = 100 * 1024; // 100KB margin
    let storageManagerInstance = null;
    let currentChatUuid = null;

    try {
        // import storage manager
        const StorageManager = require('./storage-manager').default;
        const LocalStorageManager = require('./storage-manager').LocalStorageManager;
        storageManagerInstance = StorageManager(LocalStorageManager);
        initializeStorage();
    } catch (e) {
        storageManagerInstance = null;
    }

    // initial render of chat session list on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', renderChatSessionList);
    } else {
        renderChatSessionList();
    }

    // #region functions for managing chat sessions
    
    // initialize storage with empty uuid session if no uuid is present, this allows us to have a "current" session to add messages at first load
    function initializeStorage() {
        let allSessions = getAllChatSessions();
        let sessions = allSessions.filter(s => s.chat_uuid !== '');
        ensureMessagesVm(getCurrentChatUuid() || '');
        // if there are sessions, check for the empty-uuid session and update its greeting (avoid interfering with custom greetings)
        if (sessions.length > 0) {
            let emptyIdx = allSessions.findIndex(s => s.chat_uuid === '');
            if (emptyIdx !== -1) {
                let emptySession = allSessions[emptyIdx];
                if (emptySession.messages && emptySession.messages.length > 0) {
                    emptySession.messages[0].text = `<p>${window.aiChatGreeting}</p>`;
                    emptySession.messages[0].at = new Date().toISOString();
                }
                emptySession.lastActive = new Date().toISOString();
                allSessions[emptyIdx] = emptySession;
                setAllChatSessions(allSessions);
            }
            return;
        }
        const session = { chat_uuid: '', messages: [{ text: `<p>${window.aiChatGreeting}</p>`, who: 'bot', at: new Date().toISOString() }], lastActive: new Date().toISOString() };
        sessions.unshift(session);
        setAllChatSessions(sessions);
        currentChatUuid = '';
    }

    // utility to estimate localStorage usage in bytes
    function getLocalStorageSize() {
        let total = 0;
        for (let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) continue;
            let value = localStorage.getItem(key);
            total += key.length + (value ? value.length : 0);
        }
        return total;
    }

    // remove the oldest message from any chat session
    function removeOldestMessageFromAnyChat() {
        let sessions = getAllChatSessions();
        let oldest = { idx: -1, msgIdx: -1, at: null };
        sessions.forEach((session, sIdx) => {
            if (session.messages && session.messages.length > 0) {
                let firstMsg = session.messages[0];
                if (!oldest.at || new Date(firstMsg.at) < new Date(oldest.at)) {
                    oldest = { idx: sIdx, msgIdx: 0, at: firstMsg.at };
                }
            }
        });
        if (oldest.idx !== -1) {
            sessions[oldest.idx].messages.shift();
            setAllChatSessions(sessions);
        }
    }

    function closeChat() {
        const modal = chatModalVm.$el;
        if (modal) chatModalVm.opened = false;
        document.body.classList.remove('chat-open');
    }

    function renderChatSessionList() {
        const listEl = document.getElementById('chatSessionList');
        if (!listEl) return;
        const allSessions = getAllChatSessions();
        // avoid uuid empty one
        const sessions = allSessions.filter(x => x.chat_uuid !== '');
        const curr = getCurrentChatUuid();
        listEl.innerHTML = '';
        if (!sessions || sessions.length === 0) return;
        sessions.forEach(session => {
            const li = document.createElement('li');
            li.className = 'chat-modal__content__history__sessions__list-item' + (session.chat_uuid === curr ? ' chat-modal__content__history__sessions__list-item--active' : '');
            li.setAttribute('data-chat-uuid', session.chat_uuid);
            // show first user message or date as label
            let label = 'New Chat';
            if (session.messages && session.messages.length > 0) {
                const firstUserMsg = session.messages.find(m => m.who === 'user');
                label = firstUserMsg ? firstUserMsg.text : 'Chat';
            }
            const date = formatDate(new Date(session.lastActive));
            li.innerHTML = `
                <div class="message-icon"></div>
                <div class="message-info">
                    <div class="chat-session-label">${label}</div>
                    <div class="chat-session-date">${date}</div>
                </div>
            `;
            listEl.appendChild(li);
        });
    }

    // store all sessions in localStorage under CHAT_STORAGE_KEY as an array
    function getAllChatSessions() {
        try {
            let raw;
            if (storageManagerInstance) {
                raw = storageManagerInstance.get(CHAT_STORAGE_KEY);
            } else {
                raw = localStorage.getItem(CHAT_STORAGE_KEY);
            }
            return raw ? JSON.parse(raw) : [];
        } catch (err) {
            return [];
        }
    }

    function getCurrentChatUuid() {
        if (currentChatUuid) return currentChatUuid;
        let chat_uuid = null;
        if (storageManagerInstance) {
            chat_uuid = storageManagerInstance.get('CURRENT_CHAT_UUID');
        } else {
            chat_uuid = localStorage.getItem('CURRENT_CHAT_UUID');
        }
        return chat_uuid;
    }

    function setCurrentChatUuid(chat_uuid) {
        if (storageManagerInstance) {
            storageManagerInstance.set('CURRENT_CHAT_UUID', chat_uuid);
        } else {
            localStorage.setItem('CURRENT_CHAT_UUID', chat_uuid);
        }
        currentChatUuid = chat_uuid;
        renderChatSessionList();
    }

    function createNewChatSession(byNewChatButton) {
        // remove any other empty-uuid sessions (should only be one at a time)
        let sessions = getAllChatSessions().filter(s => s.chat_uuid === '');
        // do not create a new one if there is already an empty-uuid session
        if (sessions.length === 0) {
            let allSessions = getAllChatSessions().filter(s => s.chat_uuid !== '');
            const session = { chat_uuid: '', messages: [{ text: `<p>${window.aiChatGreeting}</p>`, who: 'bot', at: new Date().toISOString() }], lastActive: new Date().toISOString() };
            allSessions.push(session);
            setAllChatSessions(allSessions);
        }
        if (byNewChatButton) {
            if (storageManagerInstance) {
                storageManagerInstance.set('CURRENT_CHAT_UUID', '');
            } else {
                localStorage.setItem('CURRENT_CHAT_UUID', '');
            }
            currentChatUuid = '';
            renderMessages('');
        }
        renderChatSessionList();
        return;
    }

    function formatDate(date) {
        const d = new Date(date);
        const datePart = new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }).format(d);
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        })
            .format(d)
            .replace(' AM', 'AM')
            .replace(' PM', 'PM');
        return `${datePart} ${timePart}`;
    }

    // delete a chat session by chat_uuid
    function deleteChatSession(chat_uuid) {
        let sessions = getAllChatSessions();
        sessions = sessions.filter(s => s.chat_uuid !== chat_uuid);
        setAllChatSessions(sessions);
        // if deleted chat was current, switch to most recent or set to empty which belongs to new chat
        if (currentChatUuid === chat_uuid) {
            if (sessions.length > 0) {
                setCurrentChatUuid(sessions[0].chat_uuid);
                renderMessages(sessions[0].chat_uuid);
            }
        } else {
            if (sessions.length === 1 && sessions[0].chat_uuid === '') {
                setCurrentChatUuid('');
                renderMessages('');
            }
            else {
                setCurrentChatUuid(sessions[0].chat_uuid);
                renderMessages(sessions[0].chat_uuid);
            }
        }
    }

    // #endregion

}
